import React from "react";
import Banner from "../../Components/SummerCamp/Banner/Banner";
import Blurbs from "../../Components/SummerCamp/Blurbs/Blurbs";
import UpcomingEvents from "../../Components/SummerCamp/UpcomingEvents/UpcomingEvents";
import USP from "../../Components/SummerCamp/USP/USP";
import "./style.css";
import SEO from "../../Components/SEO";

export default function SummerCamp() {
  return (
    <div className="summer-container">
      <SEO
        title="BWC Sports | Summer camp"
        description=""
        url="https://summercamp.bwcsports.com/"
      />
      <Banner />
      <Blurbs />
      <UpcomingEvents />
      <USP />
    </div>
  );
}
